import { render } from "./FieldForm.vue?vue&type=template&id=4b3f887e&scoped=true&ts=true"
import script from "./FieldForm.vue?vue&type=script&lang=ts"
export * from "./FieldForm.vue?vue&type=script&lang=ts"

import "./FieldForm.vue?vue&type=style&index=0&id=4b3f887e&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3f887e"]])

export default __exports__